import React from "react";

export type BadgeColor = "blue" | "orange" | "green" | "red" | "teal" | "neutral";

interface BadgeProps {
  color?: BadgeColor;
  children: React.ReactNode;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ color = "blue", children, className = "" }) => (
  <span className={`ds-badge ds-badge-${color} ${className}`}>{children}</span>
);

export default Badge;
